document.addEventListener('DOMContentLoaded', function() {
  var philosophySection = document.querySelector('.js-aboutPhilosophySection');
  var navItems = Array.prototype.slice.call(document.querySelectorAll('.js-aboutSectionNavItem'));
  var mediaQuery = window.matchMedia('(min-width: 900px)');
  var isWatching = false;
  var ticking = false;

  if (!philosophySection || navItems.length === 0) {
    return;
  }

  function resetNavItems() {
    navItems.forEach(function(navItem) {
      navItem.classList.remove('is-over-philosophy');
    });
  }

  function isCenterOverTarget(rect, targetRect) {
    var centerY = rect.top + (rect.height / 2);

    return (
      centerY >= targetRect.top &&
      centerY <= targetRect.bottom &&
      rect.right > targetRect.left &&
      rect.left < targetRect.right
    );
  }

  function animateColorChange(navItem) {
    navItem.classList.remove('is-color-changing');
    navItem.offsetWidth;
    navItem.classList.add('is-color-changing');

    window.setTimeout(function() {
      navItem.classList.remove('is-color-changing');
    }, 1000);
  }

  function updateNavItemColors() {
    ticking = false;

    if (!mediaQuery.matches) {
      resetNavItems();
      return;
    }

    var philosophyRect = philosophySection.getBoundingClientRect();

    navItems.forEach(function(navItem) {
      var navItemRect = navItem.getBoundingClientRect();
      var isOverPhilosophy = isCenterOverTarget(navItemRect, philosophyRect);

      if (navItem.classList.contains('is-over-philosophy') !== isOverPhilosophy) {
        animateColorChange(navItem);
      }

      navItem.classList.toggle('is-over-philosophy', isOverPhilosophy);
    });
  }

  function requestUpdate() {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(updateNavItemColors);
  }

  function handleMediaQueryChange() {
    if (mediaQuery.matches) {
      startWatching();
    } else {
      stopWatching();
    }
  }

  function startWatching() {
    if (isWatching) {
      requestUpdate();
      return;
    }

    isWatching = true;
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    requestUpdate();
  }

  function stopWatching() {
    if (!isWatching) {
      resetNavItems();
      return;
    }

    isWatching = false;
    window.removeEventListener('scroll', requestUpdate);
    window.removeEventListener('resize', requestUpdate);
    resetNavItems();
  }

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', handleMediaQueryChange);
  } else if (mediaQuery.addListener) {
    mediaQuery.addListener(handleMediaQueryChange);
  }

  handleMediaQueryChange();
});
